export default "__VITE_ASSET__Cl_hkFsD__"